import ActionTypes from '../constants/action-types';
import { RootActionTypes } from '../../../stores/types';
import { InvoicesState } from '../types';

const initialState: InvoicesState = {
  results: {
    businessInvoices: [],
    consumerInvoices: [],
    businessCreditMemos: [],
    creditMemos: [],
    feeInvoices: [],
  },
  failedTypes: [],
};

export default function invoices(state = initialState, action: RootActionTypes): InvoicesState {
  switch (action.type) {
    case ActionTypes.FETCH_INVOICES_REQUEST:
      return initialState;
    case ActionTypes.FETCH_INVOICES_SUCCESS:
      return {
        results: {
          businessInvoices: action.payload.b2bInvoices,
          consumerInvoices: action.payload.consumerInvoices,
          creditMemos: action.payload.creditMemos,
          businessCreditMemos: action.payload.b2bCreditMemos,
          feeInvoices: action.payload.feeInvoices,
        },
        failedTypes: action.payload.failedTypes,
      };
    case ActionTypes.FETCH_INVOICES_FAILURE:
      return {
        ...initialState,
        error: action.payload,
      };
    default:
      return state;
  }
}
